var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-page',[(_vm.creatorGallery)?_c('div',[_c('b-btn',{staticClass:"pl-0",attrs:{"variant":"link","size":"lg"},on:{"click":function($event){return _vm.$router.push({
                    name: 'creatorGalleryView',
                    params: {
                        id: _vm.creatorGallery.id,
                    },
                })}}},[_c('font-awesome-icon',{attrs:{"size":"lg","icon":"fa-light fa-chevron-left"}}),_vm._v(" "+_vm._s(_vm.$t("Back"))+" ")],1),(_vm.creatorGallery)?_c('div',{key:_vm.creatorGallery.id},[_c('creator-gallery-share-followers')],1):_vm._e()],1):_c('div',[_c('generic-loading')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }